const $ = require('jquery');
const currentURL = window.location.href;

// highlight current menu-item
$('.site-footer__nav .menu__link').each(function () {
    let url = $(this).attr('href');

    if (url === currentURL) {
        $(this).closest('.menu__item').addClass('menu__item--current');
    }
});
